module.exports = {"component":"radio","status":"prod","display-name":"Radios","last-accessibility-review":{"date-iso-8601":"2018/01/18","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/radio-group/","url-slug":"radios"}


//////////////////
// WEBPACK FOOTER
// ./components/radio/docs.json
// module id = 214
// module chunks = 0